export const homePageTranslations = {
    ru: {
        welcome: "Добро пожаловать в",
        appName: "Виртуоз",
        subtitle: "Создавайте уникальный контент с помощью искусственного интеллекта",
        description: "Генерируйте видео, стихи, песни, объединяйте и оживляйте фотографии - все в одном месте",
        getStarted: "Начать работу",
        exploreTools: "Исследуйте наши инструменты",
        generateVideo: "Сгенерировать видео",
        generateVideoDesc: "Создавайте уникальные видео с помощью ИИ",
        generatePoem: "Сгенерировать стихи",
        generatePoemDesc: "Создавайте красивые стихи на любую тему",
        generateSong: "Сгенерировать песню",
        generateSongDesc: "Превращайте текст в музыкальные композиции",
        mergePhotos: "Объединение фото",
        mergePhotosDesc: "Объединяйте несколько фотографий в одну",
        animatePhoto: "Оживление фото",
        animatePhotoDesc: "Добавляйте анимацию к вашим фотографиям",
        features: "Возможности",
        featuresTitle: "Почему выбирают нас",
        feature1Title: "Искусственный интеллект",
        feature1Desc: "Используем передовые технологии ИИ для создания контента",
        feature2Title: "Простота использования",
        feature2Desc: "Интуитивный интерфейс, с которым легко работать",
        feature3Title: "Быстрые результаты",
        feature3Desc: "Получайте готовый контент за считанные минуты",
        subscribeTitle: "Присоединяйтесь к нашему сообществу",
        subscribeDescription: "Подписывайтесь на наш канал и сообщество, чтобы быть в курсе всех новостей и обновлений",
        subscribeChannel: "Канал",
        subscribeCommunity: "Сообщество",
    },
    en: {
        welcome: "Welcome to",
        appName: "Virtuos",
        subtitle: "Create unique content with artificial intelligence",
        description: "Generate videos, poems, songs, merge and animate photos - all in one place",
        getStarted: "Get Started",
        exploreTools: "Explore our tools",
        generateVideo: "Generate Video",
        generateVideoDesc: "Create unique videos with AI",
        generatePoem: "Generate Poem",
        generatePoemDesc: "Create beautiful poems on any topic",
        generateSong: "Generate Song",
        generateSongDesc: "Turn text into musical compositions",
        mergePhotos: "Merge Photos",
        mergePhotosDesc: "Combine multiple photos into one",
        animatePhoto: "Animate Photo",
        animatePhotoDesc: "Add animation to your photos",
        features: "Features",
        featuresTitle: "Why choose us",
        feature1Title: "Artificial Intelligence",
        feature1Desc: "We use advanced AI technologies to create content",
        feature2Title: "Easy to use",
        feature2Desc: "Intuitive interface that's easy to work with",
        feature3Title: "Fast results",
        feature3Desc: "Get ready content in minutes",
        subscribeTitle: "Join our community",
        subscribeDescription: "Subscribe to our channel and community to stay updated with all news and updates",
        subscribeChannel: "Channel",
        subscribeCommunity: "Community",
    },
};
export const toolDescriptions = {
    generateVideo: {
        ru: "Создавайте уникальные видео с помощью ИИ",
        en: "Create unique videos with AI",
    },
    generatePoem: {
        ru: "Создавайте красивые стихи на любую тему",
        en: "Create beautiful poems on any topic",
    },
    generateSong: {
        ru: "Превращайте текст в музыкальные композиции",
        en: "Turn text into musical compositions",
    },
    mergePhotos: {
        ru: "Объединяйте несколько фотографий в одну",
        en: "Combine multiple photos into one",
    },
    animatePhoto: {
        ru: "Добавляйте анимацию к вашим фотографиям",
        en: "Add animation to your photos",
    },
    generateGreetings: {
        ru: "Создавайте персональные поздравления для любого праздника",
        en: "Create personal greetings for any occasion",
    },
    myGreetings: {
        ru: "Просматривайте и управляйте вашими поздравлениями",
        en: "View and manage your greetings",
    },
    vocalRemoval: {
        ru: "Удаляйте вокал из аудиофайлов с помощью ИИ",
        en: "Remove vocals from audio files with AI",
    },
    myVocalRemoval: {
        ru: "Просматривайте и управляйте обработанными аудиофайлами",
        en: "View and manage processed audio files",
    },
    portraitGeneration: {
        ru: "Создавайте уникальные портреты с помощью ИИ",
        en: "Create unique portraits with AI",
    },
    myPortraits: {
        ru: "Просматривайте и управляйте вашими портретами",
        en: "View and manage your portraits",
    },
    clipGeneration: {
        ru: "Создавайте музыкальные клипы с помощью ИИ",
        en: "Create music clips with AI",
    },
    myClips: {
        ru: "Просматривайте и управляйте вашими клипами",
        en: "View and manage your clips",
    },
};
